// extracted by mini-css-extract-plugin
export default {"statusMessage":"StatusMessage_statusMessage__gWSAM","success":"StatusMessage_success__5z94G","error":"StatusMessage_error__+psYS"};